import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { warehouseexecApi, type PickTask } from '../../api/warehouseexec';

export function PickingDashboardPage() {
  const [tasks, setTasks] = useState<PickTask[]>([]);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState('');

  useEffect(() => {
    void warehouseexecApi.listPickTasks().then(setTasks).catch((e) => setError(String(e)));
  }, []);

  async function confirmFirst() {
    if (!tasks.length) return;
    setBusy('Confirming pick…');
    try {
      await warehouseexecApi.confirmPick({
        task_id: tasks[0].id,
        worker_id: 'worker-1',
        barcode: tasks[0].bin_id ?? 'SCAN',
        items: [{ item_id: 'auto', picked_qty: 1 }],
      });
      const next = await warehouseexecApi.listPickTasks();
      setTasks(next);
    } catch (e) {
      setError(String(e));
    } finally {
      setBusy('');
    }
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/warehouse" className="text-sm text-slate-600 hover:underline">← Warehouse hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Picking dashboard</h1>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      <button type="button" onClick={() => void confirmFirst()} disabled={!!busy || !tasks.length}
        className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm text-white disabled:opacity-50">
        {busy || 'Confirm first pending pick'}
      </button>
      <div className="mt-6 overflow-x-auto rounded-xl border">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-slate-50">
            <tr>
              <th className="p-3">Task</th>
              <th className="p-3">Job</th>
              <th className="p-3">Zone</th>
              <th className="p-3">Bin</th>
              <th className="p-3">Route</th>
              <th className="p-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {tasks.map((t) => (
              <tr key={t.id} className="border-t">
                <td className="p-3 font-mono text-xs">{t.id.slice(0, 8)}</td>
                <td className="p-3">{t.job_id.slice(0, 8)}</td>
                <td className="p-3">{t.zone_id || '—'}</td>
                <td className="p-3">{t.bin_id || '—'}</td>
                <td className="p-3">{t.route_seq}</td>
                <td className="p-3">{t.status}</td>
              </tr>
            ))}
            {!tasks.length && <tr><td colSpan={6} className="p-6 text-slate-500">No pick tasks</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
